import React from 'react';
import { motion } from 'framer-motion';
import { Activity, Droplet, HeartPulse, ShieldAlert, PieChart, RefreshCcw } from 'lucide-react';
const modules = [{
  num: 1,
  icon: Activity,
  title: 'Salud Intestinal & SIBO',
  desc: 'Abordaje de microbiota, guía Low FODMAP y fases de eliminación y reintroducción.'
}, {
  num: 2,
  icon: Droplet,
  title: 'Eje Metabólico & Insulina',
  desc: 'Macronutrientes, índice glucémico aplicado y manejo del pico de glucosa postprandial.'
}, {
  num: 3,
  icon: HeartPulse,
  title: 'Abordaje Hormonal & SOP',
  desc: 'Nutrición para el eje endócrino femenino, manejo del cortisol y ciclos irregulares.'
}, {
  num: 4,
  icon: ShieldAlert,
  title: 'Nutrición Antiinflamatoria',
  desc: 'Listas de alimentos pro y antiinflamatorios y protocolo de eliminación de gatillantes.'
}, {
  num: 5,
  icon: PieChart,
  title: 'Porciones y Equivalencias',
  desc: 'Guía visual de porciones reales y reemplazos, para entender sin pesar ni medir.'
}, {
  num: 6,
  icon: RefreshCcw,
  title: 'Mantenimiento a Largo Plazo',
  desc: 'El alta exitosa: sostener el resultado sin efecto rebote ni dependencia.'
}];
export function ModulesSection() {
  return <section className="py-12 md:py-16 bg-[#064e3b] text-white" data-id="element-105">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-106">
        <div className="text-center mb-8" data-id="element-107">
          <span className="inline-flex items-center gap-2 px-6 py-2.5 mb-4 rounded-full border border-emerald-400/30 bg-emerald-800/50 text-emerald-200 font-bold tracking-[0.15em] uppercase text-xs" data-id="element-108">
            EL NÚCLEO DEL MASTERPACK
          </span>
          <h2 className="font-heading font-bold text-white md:text-5xl text-[24px]" data-id="element-109">
            6 Protocolos Clínicos de Élite{' '}
            <span className="text-yellow-400" data-id="element-110">Listos para Usar</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-111">
          {modules.map((m, i) => {
          const Icon = m.icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-emerald-900/50 border border-emerald-700/50 rounded-2xl p-5 hover:border-emerald-400/50 transition-colors" data-id="element-112">
                <div className="flex items-center gap-3 mb-2.5" data-id="element-113">
                  <div className="w-10 h-10 rounded-xl bg-emerald-800/50 flex items-center justify-center flex-shrink-0" data-id="element-114">
                    <Icon className="w-5 h-5 text-emerald-400" data-id="element-115" />
                  </div>
                  <span className="text-3xl font-black text-emerald-800/50" data-id="element-116">
                    0{m.num}
                  </span>
                </div>
                <h3 className="font-heading font-bold text-lg mb-1.5 text-white" data-id="element-117">
                  {m.title}
                </h3>
                <p className="text-emerald-100/80 leading-relaxed text-sm" data-id="element-118">
                  {m.desc}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}